export const uk = {
    'robot-ne-smozhet-vvesti':
        'Для подтверждения того, что Вы человек, а не программа, введите, пожалуйста, контрольные символы. Запрос символов периодически предпринимается для более надежного обеспечения конфиденциальности вашей информации.',
    send: 'Отправить',
    'vvedite-simvoly-s-kartinki': 'Введите символы'
};
